/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */

import Two from "pages/StepPages/StepFour/Two/Two";
import One from "pages/StepPages/StepFour/One/One";

/**
 * One - для перехода по адресу 4.1
 * One - для перехода по адресу 4.2
 */
const StepFour = {
	One,
	Two,
};
export default StepFour;
